// Security utility functions to prevent unauthorized access and copying
export const initSecurity = () => {
  // Prevent right-click context menu
  document.addEventListener('contextmenu', (e) => {
    e.preventDefault();
    return false;
  });

  // Prevent drag and drop
  document.addEventListener('dragstart', (e) => {
    e.preventDefault();
    return false;
  });

  document.addEventListener('drop', (e) => {
    e.preventDefault();
    return false;
  });

  document.addEventListener('dragover', (e) => {
    e.preventDefault();
    return false;
  });

  // Prevent text selection
  document.addEventListener('selectstart', (e) => {
    e.preventDefault();
    return false;
  });

  // Prevent copy, cut, paste keyboard shortcuts
  document.addEventListener('keydown', (e) => {
    // Ctrl+C, Ctrl+A, Ctrl+X, Ctrl+V, Ctrl+S, Ctrl+P
    if (e.ctrlKey && (
      e.key === 'c' || e.key === 'C' ||
      e.key === 'a' || e.key === 'A' ||
      e.key === 'x' || e.key === 'X' ||
      e.key === 'v' || e.key === 'V' ||
      e.key === 's' || e.key === 'S' ||
      e.key === 'p' || e.key === 'P'
    )) {
      e.preventDefault();
      return false;
    }

    // F12 (allow developer tools)
    if (e.key === 'F12') {
      return true; // Allow F12
    }

    // Disable F11 (fullscreen)
    if (e.key === 'F11') {
      e.preventDefault();
      return false;
    }

    // Disable Print Screen
    if (e.key === 'PrintScreen') {
      e.preventDefault();
      return false;
    }

    // Disable Alt+Tab, Alt+F4, Ctrl+Alt+Del
    if (e.altKey && (e.key === 'Tab' || e.key === 'F4')) {
      e.preventDefault();
      return false;
    }

    // Disable Ctrl+Shift+I (DevTools)
    if (e.ctrlKey && e.shiftKey && e.key === 'I') {
      e.preventDefault();
      return false;
    }

    // Disable Ctrl+Shift+J (Console)
    if (e.ctrlKey && e.shiftKey && e.key === 'J') {
      e.preventDefault();
      return false;
    }

    // Disable Ctrl+U (View Source)
    if (e.ctrlKey && e.key === 'u') {
      e.preventDefault();
      return false;
    }

    // Disable Ctrl+Shift+C (Element Inspector)
    if (e.ctrlKey && e.shiftKey && e.key === 'C') {
      e.preventDefault();
      return false;
    }
  });

  // Prevent print
  window.addEventListener('beforeprint', (e) => {
    e.preventDefault();
    return false;
  });

  // Prevent print via Ctrl+P
  document.addEventListener('keydown', (e) => {
    if (e.ctrlKey && e.key === 'p') {
      e.preventDefault();
      return false;
    }
  });

  // Disable text selection via CSS
  const style = document.createElement('style');
  style.textContent = `
    * {
      -webkit-user-select: none !important;
      -moz-user-select: none !important;
      -ms-user-select: none !important;
      user-select: none !important;
      -webkit-touch-callout: none !important;
      -webkit-tap-highlight-color: transparent !important;
    }
    
    input, textarea {
      -webkit-user-select: text !important;
      -moz-user-select: text !important;
      -ms-user-select: text !important;
      user-select: text !important;
    }
    
    /* Hide content when printing */
    @media print {
      * {
        display: none !important;
      }
    }
  `;
  document.head.appendChild(style);

  // Prevent screenshot attempts
  document.addEventListener('keydown', (e) => {
    // Disable Windows Snipping Tool (Win+Shift+S)
    if (e.key === 'Meta' || e.key === 'Windows') {
      // Allow but monitor
    }
  });

  // Disable right-click on images
  document.addEventListener('contextmenu', (e) => {
    if (e.target.tagName === 'IMG') {
      e.preventDefault();
      return false;
    }
  });

  // Prevent image dragging
  document.addEventListener('dragstart', (e) => {
    if (e.target.tagName === 'IMG') {
      e.preventDefault();
      return false;
    }
  });

  // Disable text selection on images
  document.addEventListener('selectstart', (e) => {
    if (e.target.tagName === 'IMG') {
      e.preventDefault();
      return false;
    }
  });

  // Prevent F12 alternatives
  document.addEventListener('keydown', (e) => {
    // Disable Ctrl+Shift+I (DevTools)
    if (e.ctrlKey && e.shiftKey && e.key === 'I') {
      e.preventDefault();
      return false;
    }
    
    // Disable Ctrl+Shift+J (Console)
    if (e.ctrlKey && e.shiftKey && e.key === 'J') {
      e.preventDefault();
      return false;
    }
    
    // Disable Ctrl+Shift+K (Console in Firefox)
    if (e.ctrlKey && e.shiftKey && e.key === 'K') {
      e.preventDefault();
      return false;
    }
  });

  // Console warnings removed for cleaner developer experience

  // Disable common developer shortcuts
  document.addEventListener('keydown', (e) => {
    // Disable Ctrl+Shift+Delete (Clear browsing data)
    if (e.ctrlKey && e.shiftKey && e.key === 'Delete') {
      e.preventDefault();
      return false;
    }
  });

  // Prevent iframe embedding
  if (window.top !== window.self) {
    window.top.location = window.self.location;
  }

  // Zoom is now allowed for better user experience

  console.log('🔒 Security measures initialized');
};

// Function to temporarily disable security for form inputs
export const enableFormInputs = () => {
  const inputs = document.querySelectorAll('input, textarea');
  inputs.forEach(input => {
    input.style.userSelect = 'text';
    input.addEventListener('selectstart', (e) => {
      e.stopPropagation();
    });
  });
};

// Function to re-enable security after form interaction
export const disableFormInputs = () => {
  const inputs = document.querySelectorAll('input, textarea');
  inputs.forEach(input => {
    input.style.userSelect = 'none';
  });
};
